import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query allHeadquarterActivated {
        headquarterActive {
            id
            name
            is_active
            status_text
            employees {
                employee_id
                headquarter_id
                employee {
                    is_active
                }
            }
        }
    }
`

/**
 * Mutations
 */

export {
    ALL_ACTIVE
}
